export const MIN_CAROUSEL_HEIGHT = 100;
export const MAX_HEIGHT_UPDATES = 10;
